var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutlery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C15.0858 0 14.75 0.335786 14.75 0.75V23C14.75 23.5523 15.1977 24 15.75 24C16.3023 24 16.75 23.5523 16.75 23V15C16.75 14.7239 16.9739 14.5 17.25 14.5H19C19.3321 14.5019 19.6511 14.3708 19.886 14.136C20.1208 13.9011 20.2519 13.5821 20.25 13.25V13.243C20.186 6.055 17.832 0 15.5 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 0C10.1977 0 9.75 0.447715 9.75 1V6C9.75094 6.52355 9.54583 7.02645 9.179 7.4C9.10758 7.47184 8.99998 7.49371 8.90619 7.45545C8.81239 7.41719 8.75079 7.3263 8.75 7.225V1C8.75 0.447715 8.30228 0 7.75 0C7.19772 0 6.75 0.447715 6.75 1V7.223C6.74921 7.3243 6.68761 7.41519 6.59381 7.45345C6.50002 7.49171 6.39242 7.46984 6.321 7.398C5.95465 7.02494 5.74958 6.52286 5.75 6V1C5.75 0.447715 5.30228 0 4.75 0C4.19772 0 3.75 0.447715 3.75 1V6C3.75242 7.69464 4.82012 9.20473 6.417 9.772C6.6165 9.84269 6.74988 10.0313 6.75 10.243V23C6.75 23.5523 7.19772 24 7.75 24C8.30228 24 8.75 23.5523 8.75 23V10.243C8.75012 10.0313 8.8835 9.84269 9.083 9.772C10.6799 9.20473 11.7476 7.69464 11.75 6V1C11.75 0.447715 11.3023 0 10.75 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery);
export default __webpack_public_path__ + "static/media/cutlery.c951fdbd.svg";
export { ForwardRef as ReactComponent };